import { render, staticRenderFns } from "./OnlyTwo.vue?vue&type=template&id=0b9717e8&scoped=true"
import script from "./OnlyTwo.vue?vue&type=script&lang=ts"
export * from "./OnlyTwo.vue?vue&type=script&lang=ts"
import style0 from "./OnlyTwo.vue?vue&type=style&index=0&id=0b9717e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9717e8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowGalleryMultipleImageWrapper: require('/usr/src/nuxt-app/components/show/gallery/MultipleImageWrapper.vue').default,ShowGalleryImageWrapper: require('/usr/src/nuxt-app/components/show/gallery/ImageWrapper.vue').default})
